export function supportsCountry(country) {
  return ['se', 'no', 'fi'].includes(country);
}
